import { getUserFromLS } from "../utils/getUserFromLS";
import { resolveTenantClientId } from "../utils/tenantClientId";

export function buildOrchestratorHeaders(
  explicitClientId?: string | null
): Record<string, string> {
  const user = getUserFromLS();
  const headers: Record<string, string> = {
    Authorization: `Bearer ${user.access_token}`,
  };
  const tenantClientId = resolveTenantClientId(explicitClientId);
  if (tenantClientId != null && tenantClientId !== "") {
    headers["X-Client-Id"] = tenantClientId;
  }
  return headers;
}

export function resolveOrchestratorTenantClientId(
  explicitClientId?: string | null
): string | null {
  return resolveTenantClientId(explicitClientId);
}
